import { useTranslation } from 'react-i18next'
import { useAuth } from './hooks'

export function UnauthorizedPage({ portalName }: { portalName: string }) {
  const { logout } = useAuth()
  const { t } = useTranslation()

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-2xl font-bold">{t('auth.accessDenied')}</h1>
      <p className="text-foreground/60">{t('auth.noPermission', { portalName })}</p>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground transition-opacity hover:opacity-80"
        onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      >
        {t('common.signOut')}
      </button>
    </div>
  )
}
